module.exports = __webpack_public_path__ + "static/media/MinuteMail_Logo-03_1590163208745.763d3679.jpg";